exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/projects/project-template/project-template.component.css
// module id = ../../../../../src/app/projects/project-template/project-template.component.css
// module chunks = main